import Phaser from "phaser";
import { COLORS } from "../constants";
import { PrimitiveAvatar, PrimitiveAvatarOptions } from "./PrimitiveAvatar";
import { PrimitiveBlueprint } from "./types";

export class PlayerAvatarView {
  private avatar: PrimitiveAvatar;
  private scene: Phaser.Scene;
  private defendingIndicator?: Phaser.GameObjects.Container;

  constructor(
    scene: Phaser.Scene,
    blueprint: PrimitiveBlueprint,
    options?: PrimitiveAvatarOptions
  ) {
    this.scene = scene;
    this.avatar = new PrimitiveAvatar(scene, blueprint, options);
  }

  setPosition(x: number, y: number) {
    this.avatar.setPosition(x, y);
  }

  setSelected(on: boolean) {
    this.avatar.setSelected(on);
  }

  setAlive(on: boolean) {
    this.avatar.setAlive(on);
  }

  /** Show or hide persistent defending indicator */
  setDefending(on: boolean, _armorValue?: number) {
    if (on) {
      if (!this.defendingIndicator) {
        this.createDefendingIndicator();
      }
      this.defendingIndicator?.setVisible(true);
    } else {
      this.defendingIndicator?.setVisible(false);
    }
  }

  private createDefendingIndicator() {
    const bounds = this.avatar.getWorldBounds();
    const shieldColor = Phaser.Display.Color.HexStringToColor(COLORS.shieldText).color;

    this.defendingIndicator = this.scene.add.container(bounds.centerX, bounds.top - 20);

    // Shield background
    const shield = this.scene.add.rectangle(0, 0, 36, 36, shieldColor, 0.3);
    shield.setStrokeStyle(2, shieldColor, 0.8);

    // Shield icon text
    const icon = this.scene.add
      .text(0, 0, "🛡️", {
        fontSize: "20px",
      })
      .setOrigin(0.5);

    this.defendingIndicator.add([shield, icon]);
    this.defendingIndicator.setDepth(100);
  }

  playHit() {
    this.avatar.playHit();
  }

  playHeal() {
    this.avatar.playHeal();
  }

  playDefend() {
    this.avatar.playDefend();
  }

  getRoot(): Phaser.GameObjects.Container {
    return this.avatar.getRoot();
  }

  getWorldCenter() {
    return this.avatar.getWorldCenter();
  }

  getWorldBounds() {
    return this.avatar.getWorldBounds();
  }

  destroy() {
    this.defendingIndicator?.destroy(true);
    this.avatar.destroy();
  }
}
